import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RailArrows.module.css';

/** Desktop: ‹ › buttons that page a sideways rail by most of its width. */
export const RailArrows = ({
  rail,
}: {
  rail: RefObject<HTMLDivElement | null>;
}) => {
  const { t } = useTranslation();
  const page = (dir: number) => {
    const el = rail.current;
    if (el)
      el.scrollBy({ left: dir * el.clientWidth * 0.9, behavior: 'smooth' });
  };
  return (
    <div className={styles.arrows}>
      <button
        type="button"
        aria-label={t('previous_label')}
        onClick={() => page(-1)}
      >
        ‹
      </button>
      <button
        type="button"
        aria-label={t('next_label')}
        onClick={() => page(1)}
      >
        ›
      </button>
    </div>
  );
};
